module.exports = __webpack_public_path__ + "static/media/element-bg-pattern.44c7c135.jpeg";